<template>
  <v-container>
    <v-tabs v-model="activeTab">
      <v-tab v-for="circuit in circuits" :key="circuit" role="tab">
        {{ circuit }}
      </v-tab>
      <v-tab v-if="hasDuplicates" role="tab">{{ $t('page.selection.tabs.duplicates') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item v-for="circuit in circuits" :key="circuit">
        <slot :purchase-conditions="supplierPurchaseConditions[circuit]" />
      </v-tab-item>
      <v-tab-item v-if="hasDuplicates"><slot name="duplicates" :purchase-conditions="duplicates" /></v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import { PurchaseConditionsGroupByCircuit } from '@/models/purchase-condition/purchase-conditions-group-by-circuit';
import { PurchaseCondition } from '@/models/purchase-condition/purchase-condition';

export default Vue.extend({
  name: 'CircuitTabs',
  props: {
    supplierPurchaseConditions: {
      type: Object as () => PurchaseConditionsGroupByCircuit,
      required: true
    },
    duplicates: {
      type: Array as () => PurchaseCondition[],
      required: false
    }
  },
  data() {
    return {
      activeTab: null
    };
  },
  computed: {
    circuits(): (keyof PurchaseConditionsGroupByCircuit)[] {
      return (Object.keys(this.supplierPurchaseConditions) as (keyof PurchaseConditionsGroupByCircuit)[]).filter(
        value => this.supplierPurchaseConditions[value] != null
      );
    },
    hasDuplicates(): boolean {
      return this.duplicates != null && this.duplicates.length > 0;
    }
  }
});
</script>
